import styled from 'styled-components';

const ForgotPasswordText = styled.button`
  background: var(--colorBlueGray100);
  border: none;
  outline: none;
  appearance: none;
  color: var(--colorBlueGray800);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.24px;
  display: block;
  cursor: pointer;
  margin-left: auto;
  margin-bottom: 32px;
`;

const SubmitButton = styled.button<{
  disabled: boolean;
}>`
  background: linear-gradient(-180deg, rgb(65, 71, 79) 0%, rgb(28, 35, 44) 100%);
  border-radius: 4px;
  height: 64px;
  width: 100%;
  border: none;
  outline: none;
  appearance: none;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Poppins';
  letter-spacing: 0.24px;
  display: block;
  padding: 16px;
  cursor: pointer;
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  transition: opacity 0.2s ease-in-out;
`;

const ModalContent = styled.div`
  text-align: left;
`;

const Text = styled.p`
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.24px;
  line-height: 16px;
  margin: 16px 0 !important;
`;

const LabelText = styled.p`
  color: #666b71;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.24px;
  margin-bottom: 8px !important;
`;

const ErrorMessage = styled.p`
  color: #ff263d;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.24px;
  line-height: 16px;
  margin: 8px 0 32px !important;
`;

export { ForgotPasswordText, LabelText, Text, ModalContent, SubmitButton, ErrorMessage };
